const $ = require('lib/jquery')
const Raven = require('lib/raven')
const Dialog = require('module/dialog/dialog')
const log = require('log').create('verify email', 'resend')  

function resendEmail(options) {
    const user = options.user
    const user_is_in_customer_io = typeof(user.get('flags.email_verified')) === typeof(true)

    // ignore resend requests if user isn't in customer.io
    if (! user_is_in_customer_io) return

    // the backend will be doing this on resend, too
    // so making sure it matches
    user.set('flags.email_verified', false)

    $.ajax({
        type: 'GET',
        url: `${user.url()}/send_verification_email`,
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .done(res => {
            log('res', res)
            Dialog.banner(
                'A new email was sent. Click the link in the email to verify your email address.',
                { status: 'confirmation' },
            )
        })
        .fail(err => {
            let msg
            log('err', err)

            switch (err && err.type) {
            // this occurs when customer.io doesn't have
            // the address, so likely just a dev issue
                case 'EMAIL_INVALID':
                    msg = 'There is a problem with your email address. Please update it.'
                    break
                default:
                    msg = 'There was a problem sending a new email. Please try again later.'
            }

            Dialog.banner(msg, { status: 'error' })

            Raven.captureMessage('resend verify email failed', {
                extra: {
                    err,
                },
            })
        })
}

module.exports = resendEmail
